import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PrimkeService {
  constructor(private _http: HttpClient) {}

  primka_dodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_dodaj', a)
      .pipe(map((res: any) => res));
  }

  primka_uredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_uredi', a)
      .pipe(map((res: any) => res));
  }

  prometzagPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prometzagPopis', a)
      .pipe(map((res: any) => res));
  }

  primkaStavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_stavke_popis', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  primkaSviArtikli(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_svi_artikli', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSkladista(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_skladista_pekar', a)
      .pipe(map((res: any) => res));
  }
  /* 24.12.2025. */
  /* duplalo im je skladista pa je api dohvati_skladista_pekar zamjenjen */
  dohvatiSkladistaV2(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_skladista_po_firma_id', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'partner_popisV2', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSvePoslovnicepartnera(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_poslovnicepartnera', a)
      .pipe(map((res: any) => res));
  }

  primka_stavka_dodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_stavka_dodaj', a)
      .pipe(map((res: any) => res));
  }

  primka_stavka_uredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_stavka_uredi', a)
      .pipe(map((res: any) => res));
  }

  primka_stavka_obrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_stavka_obrisi', a)
      .pipe(map((res: any) => res));
  }

  primka_storno(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_storno', a)
      .pipe(map((res: any) => res));
  }

  primka_zavrsi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_zavrsi', a)
      .pipe(map((res: any) => res));
  }

  primka_obrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_obrisi', a)
      .pipe(map((res: any) => res));
  }

  povezani_dokumenti_popis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'povezani_dokumenti_popis', a)
      .pipe(map((res: any) => res));
  }

}
